import { render, staticRenderFns } from "./p11.vue?vue&type=template&id=652079cb&scoped=true&"
import script from "./p11.vue?vue&type=script&lang=js&"
export * from "./p11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652079cb",
  null
  
)

export default component.exports